module.exports = __webpack_public_path__ + "media/icons/notification_close@2x-2582c8a3.png";